export const MAX_SELECTED_CREATORS = 1000
